<template>
  <div>
    <a-row v-for="course in mineCourses" :key="course.id" class="course-item">
      <a-col :span="6">
        <div class="cover" @click="showSelectClassroom(course)">
          <img :src="course.courseCover_url" alt="" />
        </div>
      </a-col>
      <a-col :span="10">
        <div class="desc" @click="showSelectClassroom(course)">
          <a-tag class="course-type" color="orange">
            {{ course.courseType_dictText }}
          </a-tag>
          <h3>{{ course.courseName }}</h3>
          <p>{{ course.courseDesc }}</p>
        </div>
      </a-col>
      <a-col :span="8">
        <div class="btn-wrap">
          <a
            class="btn-white"
            @click="showSelectClassroom(course)"
            >去上课</a
          >
          <router-link
            class="btn"
            :to="{ name: 'teacherCourseUnit', query: { courseId: course.id } }"
            >备课</router-link
          >
        </div>
      </a-col>
    </a-row>
    <a-modal
      :visible="selectClassroom"
      :footer="null"
      title="班级选择"
      :width="400"
      @cancel="selectClassroom = false"
    >
      <div class="select-depart-btns">
        <a-button
          type="default"
          v-for="depart in selectDepartList"
          :key="depart.id"
          @click="onSelectedClassroom(depart.id)"
        >
          {{ depart.departName }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getTeacherCourse } from "@/api/course";
export default {
  name: "TeacherCourseList",
  data() {
    return {
      mineCourses: [],
      selectClassroom: false,
      selectCourseId: "",
      selectDepartList: [],
    };
  },
  created() {
    this.getMineCourse();
  },
  methods: {
    //获取我负责的班级中的课程
    getMineCourse() {
      getTeacherCourse({}).then((res) => {
        this.mineCourses = res.result;
      });
    },
    showSelectClassroom(course) {
      this.selectClassroom = true;
      this.selectCourseId = course.id;
      this.selectDepartList = course.departList;
      // this.selectDepartId = departId
    },
    onSelectedClassroom(departId) {
      this.$router.push({
        name: "teacherCourseUnit",
        query: { courseId: this.selectCourseId, departId: departId },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.btn{
  color: #fff;
  background: var(--primary-color);
}
.btn-white{
  background: #fff;
  color: var(--primary-color);
}
.course-item {
  margin: 0 0 20px;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  height: 170px;
  transition: all 0.1s ease-in;
}
.course-item:hover {
  border: 1px solid var(--primary-color);
}
.cover {
  height: 150px;
  margin-right: 10px;
  img {
    height: 100%;
    max-width: 100%;
  }
}
.desc{
  h3{
    font-size: 20px;
    font-weight: 500;
    cursor: pointer;
  }
  .course-type{
    border-radius: 8px 8px 8px 0px;
    margin-bottom: 10px;
  }
}
.btn-wrap {
  margin-top: 50px;
  a {
    display: inline-block;
    cursor: pointer;
    width: 100px;
    height: 40px;
    margin-right: 16px;
    border: 1px solid var(--primary-color);
    border-radius: 30px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
  }
}
.select-depart-btns {
  button {
    height: 40px;
    width: 300px;
    display: block;
    margin: 10px auto;
  }
}
</style>